import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import moment from "moment";
import { Link } from "react-router-dom";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import useSearchHook from "hooks/useSearch.hook";
import { getList, deleteItem } from "actions/chargers/main/actions";
import Filters from "./filters";
import { EMPTY_DASH } from "../../../../constants";
import getProgressBar from "../helpers/get-progress-bar";
import { VOLTAGE, AMPERAGE } from "../constants";

const FILTERS_KEY = "chargersList";

const Chargers = ({
                    getList,
                    deleteItem,
                    ...rest
                  }) => {
  const {
    loading,
    list,
    pages
  } = rest;

  const {
    page,
    size,
    filters,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getList, {
    size: 30,
    sort: "lastUpdatedAt,desc",
    name: FILTERS_KEY
  });

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Station QR",
      accessor: "stationQr",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.stationQr}`}>
          {original.stationQr}
        </Link>
      ),
    },
    {
      Header: "Electric Quantity",
      accessor: "electricQuantity",
    }, {
      id: "voltage",
      Header: "Voltage",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          {getProgressBar(original.voltage, VOLTAGE)}
        </div>
      )
    },
    {
      Header: "Amperage",
      accessor: "amperage",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          {getProgressBar(original.amperage, AMPERAGE)}
        </div>
      )
    },
    {
      Header: "Temperature",
      accessor: "temperature",
    },
    {
      Header: "Charging",
      accessor: "charging",
      Cell: ({ original }) => (original.charging ? "YES" : "NO"),
    },
    {
      Header: "Last Station QR",
      accessor: "lastStationQr",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.lastStationQr}`}>
          {original.lastStationQr}
        </Link>
      ),
    },
    {
      Header: "Slot",
      accessor: "slotNumber",
    },
    {
      Header: "Lock Level",
      accessor: "lockLevel",
    },
    {
      Header: "Bottom Level",
      accessor: "bottomLevel",
    },
    {
      Header: "Last Rent Date",
      accessor: "lastRentDate",
      Cell: ({ original }) => (original.lastRentDate ? moment(original.lastRentDate)
        .format("HH:mm YYYY-MM-DD") : EMPTY_DASH),
    },
    {
      Header: "Last Rent User",
      accessor: "lastRentUser",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (!original.lastRentUser) return EMPTY_DASH;
        return (
          <Link to={`/users/${original.lastRentUser}`}>
            {original.lastRentUser}
          </Link>
        );
      }
    },
    {
      Header: "Last Update Date",
      accessor: "lastUpdatedAt",
      Cell: ({ original }) => (original.lastUpdatedAt ? moment(original.lastUpdatedAt)
        .format("HH:mm YYYY-MM-DD") : EMPTY_DASH),
    },
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          name={FILTERS_KEY}
          activeFilters={filters}
          totalCount={list.total_count || 0}
          handleSearch={handleSearch}
          handleReset={handleReset}
        />
      </div>

      <ReactTable
        data={list.content || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.charger.loading,
  list: state.charger.list,
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(getList, dispatch),
  deleteItem: bindActionCreators(deleteItem, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Chargers);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/chargers/index.js